import { render, staticRenderFns } from "./SearchMenu.vue?vue&type=template&id=205147da&scoped=true"
import script from "./SearchMenu.vue?vue&type=script&lang=js"
export * from "./SearchMenu.vue?vue&type=script&lang=js"
import style0 from "./SearchMenu.vue?vue&type=style&index=0&id=205147da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205147da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
